module.exports = __webpack_public_path__ + "assets/img/401.b26cd574.png";